<template>
  <div>
    <div class="eventInformation">
      <v-container class="pt-0">
        <v-layout row wrap>
          <v-flex sm7 class="information">
            <div>
            <h4 v-if="extract('event.open')">Register for the</h4>
            <h3
              v-html="
                extract('event.content.body.title') || extract('event.name')
              "
            ></h3>

            <div
              class="event-description mr-4"
              v-html="extract('event.content.body.description')"
            ></div>

            <table
              class="event-sections"
              v-if="extract('event.content.body.sections')"
            >
              <tr
                v-for="(obj, num) in extract('event.content.body.sections')"
                v-bind:key="num"
              >
                <td class="">
                  <h4 class="section-title">
                    {{
                      extract('event.content.body.sections.' + num + '.title')
                    }}:
                  </h4>
                </td>
                <td
                  v-html="
                    extract('event.content.body.sections.' + num + '.html')
                  "
                ></td>
              </tr>
            </table>

            <h3 class="mt-5 mb-4">Sponsorship Levels</h3>

            <v-card v-for="sponsorshipLevel in sponsorshipLevels"
            v-bind:key="sponsorshipLevel.name"
            class="mb-4 pa-3">
              <div>
                <h4 class="section-title mb-2">
                    {{ sponsorshipLevel.name }}:
                </h4>
                <v-divider></v-divider>
              </div>

                  <div
                  class="sponsorshipLevelDescription"
                  v-html="
                    sponsorshipLevel.description
                  "
                ></div>
                </v-card>

            <div>
              <span
                class="capacity-notice"
                v-if="!loading && availableSlots < 1"
                >The event is currently at capacity, but sign up below to be
                added to the wait list and we'll email you if a spot opens
                up.</span
              >
            </div>
            </div>
          </v-flex>
          <v-flex sm4 xl3 offset-sm1 hidden-xs-only class="callout">
            <!-- IF DEFAULT ASIDE -->
            <div class="whiteBox pa-4" v-if="hasAside">
              <div v-if="defaultAside">
                <p>
                  <v-img src="@/assets/es/Summit_01@2x.jpg" />
                </p>
                <p>
                  <v-img src="@/assets/es/Summit_02@2x.jpg" />
                </p>
              </div>
              <div v-else class="customAside">
                <AmazeDynamicComponent
                  v-bind:template="extract('event.content.aside.html')"
                ></AmazeDynamicComponent>
              </div>
            </div>
            <!-- END DEFAULT ASIDE -->
            <div id="refund-dialog">
              <v-dialog v-model="dialog" max-width="500px">
                <v-btn
                  slot="activator"
                  color="primary"
                  style="display: none"
                  id="refund-dialog-button"
                  class="mb-4 mt-4 ml-0"
                >
                  Learn more about RTI's refund and cancellation policy
                </v-btn>
                <v-card>
                  <v-card-title>
                    <h3 class="headline">Refund and Cancellation Policy</h3>
                  </v-card-title>
                  <hr class="thick" />

                  <v-card-text>
                    <v-layout wrap>
                      <div class="pa-2 mb-2">
                        <p>
                          The {{ event.name }} Cancellation and Refund Policy
                          will be as follows to assure consistency and is
                          applicable to this event.
                        </p>
                        <p>
                          {{ event.name }} sponsorship canceled online on or
                          before {{ getFormattedDate(event.refund_expiry) }} is
                          refundable if already paid, or not due if not already
                          paid. In order for your cancellation to be received,
                          email
                          <a href="mailto:educationservices@rti.org "
                            >educationservices@rti.org</a
                          >
                          no later than
                          {{ getFormattedDate(event.refund_expiry) }}.
                        </p>
                      </div>
                    </v-layout>
                  </v-card-text>

                  <v-card-actions>
                    <v-spacer />
                    <v-btn color="blue darken-1" flat @click="dialog = false"
                      >Cancel</v-btn
                    >
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </div>
          </v-flex>
        </v-layout>
      </v-container>
    </div>

    <!-- BEGIN THE FORMATIONING -->
    <div class="registrationForm" v-if="!loading">
      <div class="text-xs-center" v-if="!extract('event.open')">
        <h4>Registration is closed for this sponsorship.</h4>
      </div>
      <v-form
        ref="regForm"
        v-model="valid"
        v-if="
          extract('event.open')
        "
      >
        <v-container>
          <v-layout>
            <v-flex md6>
              <h3>
                Registration
                <small>Required fields <span class="star">*</span></small>
              </h3>

              <v-text-field
                v-model="districtName"
                required
                :rules="rules.district"
              >
                <template slot="label"
                  >Organization Name<span class="star">*</span></template
                >
              </v-text-field>

              <div v-if="sponsorshipLevels" id="MembershipOptionsContainer">
                <h5>Sponsorship Level<span class="star">*</span></h5>
                <p>Please select from the options below.</p>
                <div v-for="n in sponsorshipLevels" :key="n.name" class="mb-3">
                  <v-checkbox class="mb-0 pb-0" v-model="sponsorshipLevel" :label="n.name" :value="n.value" required :rules="rules.option" :hint="n.hint" persistent persistent-hint></v-checkbox>
                </div>
              </div>

              <h5>Sponsor Organization Point of Contact Information</h5>

              <p>Please provide the name, email, and phone number for your organization's point of contact.</p>

              <div v-if="maxRegistrants > 1">
                <p>
                  <strong
                    >Size of school team (total registrants)<span class="star"
                      >*</span
                    ></strong
                  >
                </p>
                <p>
                  After selecting the size of your team, you will be able to
                  enter attendee information
                </p>
                <v-select
                  :items="registrantSlots"
                  label="Select Size"
                  v-model="registrants"
                  required
                  :rules="rules.size"
                  @change="initializeSlots"
                ></v-select>

                <div v-if="registrants > 0">
                  <h5>Attendee Information</h5>
                  <p>
                    Please enter the registration information (name, email and
                    role) for each person on your school team.
                    <strong>Registrant 1</strong> will receive email
                    confirmation and payment information.
                  </p>

                  <template v-for="(obj, num) in registrant">
                    <div class="registrant" :key="num">
                      <h6>Registrant {{ num + 1 }}</h6>
                      <v-text-field
                        v-model="registrant[num].name"
                        required
                        :rules="rules.name"
                      >
                        <template slot="label">
                          Registrant {{ num + 1 }}: Name<span class="star"
                            >*</span
                          >
                        </template>
                      </v-text-field>
                      <AmazeEmailAddressInput v-model="registrant[num].email">
                        <template slot="label"
                          >Registrant {{ num + 1 }}: E-mail</template
                        >
                      </AmazeEmailAddressInput>
                    </div>
                  </template>
                </div>
              </div>
              <div v-if="maxRegistrants == 1">
                <v-text-field
                  v-model="registrant[0].name"
                  required
                  :rules="rules.name"
                >
                  <template slot="label">
                    Name<span class="star">*</span>
                  </template>
                </v-text-field>
                <AmazeEmailAddressInput v-model="registrant[0].email">
                  <template slot="label">E-mail</template>
                </AmazeEmailAddressInput>
              </div>

              <div class="submit-wrapper" v-if="registrants > 0">
                <div class="submit-success" v-if="this.submittedSuccessfully">
                  <h5>Success!</h5>
                  <p>
                    <strong
                      >Thank you for registering for the
                      {{
                        extract('event.content.body.title') ||
                        extract('event.name')
                      }}!</strong
                    >
                    You should receive a confirmation email shortly. If you do
                    not receive an email, please contact
                    <a :href="'mailto:' + contactAddress">{{
                      contactAddress
                    }}</a
                    >.
                  </p>
                </div>
                <div class="submit-incomplete" v-else>
                  <h5>Complete Registration</h5>
                  <div v-if="!registrationIsSingle">
                    <p>After submitting this form, <strong>Registrant 1</strong> will receive 2 emails:
                      <ol>
                        <li>A confirmation email with your registration details and </li>
                        <li>An email with your invoice and payment instructions.</li>
                      </ol>
                      <br>Applications are due 2 weeks prior to the event.
                    </p>
                    <p v-if="false">
                      After submitting this form,
                      <strong>Registrant 1</strong> will receive an email
                      confirming your school’s registration, total fees owed
                      based on number of participants, and instructions on
                      sending in payment.
                    </p>
                    <p>
                      <strong>Please note:</strong> all team members will
                      receive an email with a personalized link to review and
                      accept terms and conditions.
                      <a
                        href="https://amaze-assets.s3.us-west-1.amazonaws.com/files/events/2025_Early_College_Summit/ECS+2025+decription+with+waiver.pdf"
                        target="_blank"
                        title="Early College Summit 2025 Terms and Conditions"
                        >The terms and conditions</a
                      >
                      must be accepted prior to the event.
                    </p>
                  </div>
                  <div v-if="registrationIsSingle">
                    <p>
                      After submitting this form, you will be prompted to review
                      our terms and conditions to finalize your sponsorship registration.
                      You will also receive an invoice and confirmation email with your
                      sponsorship details.
                    </p>
                  </div>
                  <v-btn
                    v-if="!submitted"
                    class="ml-0"
                    color="primary"
                    @click="submitRegistration()"
                    >Submit Registration</v-btn
                  >
                  <v-progress-circular v-else indeterminate />
                </div>
              </div>
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>
    </div>

    <!-- END THE FORMATIONING -->
  </div>
</template>

<style lang="scss" scoped>
@import 'src/styles/variables.scss';

#EducationServicesTemplate {
  .submit-wrapper {
    margin-top: 0px;
  }
}

.speaker-photo {
  float: left;
  max-width: 50%;
}

::v-deep .sponsorshipLevelDescription {
  ul {
    li {
      margin: 6px 0;
    }
  }
}
.sponsorshipLevelDescription {

 ul {
  border: 1px solid black;
 }
}
</style>

<script>
import registrationMixin from '@/mixins/registrationMixin.js'

export default {
  mixins: [registrationMixin],
  data () {
    return {
      dialog: false,
      loading: true,
      valid: false,
      submitted: false,

      availableSlots: 0,
      maxRegistrants: 0,
      totalAttendees: 0,

      diet: '',
      topics: '',

      schoolName: 'Early College Summit Sponsor',
      districtName: '',
      stateName: 'N/A',
      roles: ['Principal', 'Teacher', 'Counselor', 'College Liaison', 'Other'],

      earlyCollegeNetwork: 0,
      earlyCollegeNetworkOptions: [
        { text: 'Yes', value: 1 },
        { text: 'No', value: 0 }
      ],

      sponsorshipLevel: null,
      sponsorshipLevels: [
      ],

      registrants: 0,
      numRegistrants: 0,
      registrant: [],
      submittedSuccessfully: false,
      rules: {
        name: [v => !!v || 'Name is required.'],
        email: [
          v => !!v || 'Email is required.',
          v => /@/.test(v) || 'Please enter a valid email.'
        ],
        role: [v => !!v || 'Role is required.'],
        school: [v => !!v || 'School name is required.'],
        district: [v => !!v || 'District name is required.'],
        state: [v => !!v || 'State is required.'],
        size: [v => !!v || 'Team size is required.'],
        date: [v => !!v || 'Date is required.'],
        diet: [
          v =>
            (v || '').length <= 200 ||
            'Description must be 200 characters or less'
        ],
        topics: [
          v =>
            (v || '').length <= 200 ||
            'Description must be 200 characters or less'
        ],
        earlyCollegeNetwork: [
          v =>
            v === 0 ||
            v === 1 ||
            'Please specify if your school is part of the Early College Network.'
        ]
      },
      event: {}
    }
  },
  computed: {
    content () {
      //                var defaults = {};
      return event.content ? event.content : false
    },
    id () {
      return this.extract('event.id')
    },
    hasAside () {
      var aside = this.extract('event.content.aside.custom')
      return aside !== null
    },
    defaultAside () {
      return (
        !this.extract('event.content.aside.custom') ||
        !this.extract('event.content.aside.html')
      )
    },
    registrationIsSingle () {
      return this.maxRegistrants === 1
    },
    registrantSlots () {
      let slots = []
      for (let i = 1; i <= this.maxRegistrants; i++) {
        if (i === 1) {
          slots.push({ text: i + ' attendee', value: i })
        } else {
          slots.push({ text: i + ' attendees', value: i })
        }
      }
      return slots
    },
    contactAddress () {
      return process.env.VUE_APP_CONTACT_ADDRESS
    },
    loaded () {
      return !this.loading
    },
    showSubmitPrompt () {
      return !this.submittedSuccessfully && this.registrants > 0
    }
  },
  methods: {
    initializeSlots () {
      let backup = this.registrant
      this.registrant = []
      for (let person = 0; person < this.registrants; person++) {
        if (backup[person]) {
          this.registrant[person] = backup[person]
        } else {
          this.registrant[person] = {
            name: '',
            email: null,
            role: 'Sponsor Organization Point of Contact'
          }
        }
      }
    },
    submitRegistration () {
      if (this.$refs.regForm.validate()) {
        this.submitted = true
        let data = {
          school: this.schoolName,
          district: this.districtName,
          state: this.stateName,
          team_total: this.registrants,
          registration_event_id: this.extract('event.id'),
          registration_team_member: this.registrant,
          single_registration: true,
          extra_attributes: {
            'Sponsorship Level': this.sponsorshipLevel
          }
        }

        this.$http.post('registrations', data).then(
          response => {
            this.$router.push({ path: "/network/" + (this.$route.params.slug || this.$route.path.split('/').pop()) + "/terms/" + response.body.data.registration_team_member[0].uuid });
            this.$store.commit('updateMessage', {
              message:
                'Please review the terms and conditions to complete registration.',
              snackbar: true
            })
          },
          response => {
            this.submitted = false
            this.$store.commit('updateMessage', {
              message:
                'There was a problem saving your registration. Please try again or contact support.',
              snackbar: true
            })
          }
        )
      } else {
        this.$store.commit('updateMessage', {
          message: 'Required fields are missing. Please review the form.',
          snackbar: true
        })
      }
    }
  },
  mounted () {
    this.$http
      .get(
        'event/' +
          (this.$route.params.slug || this.$route.path.split('/').pop())
      )
      .then(
        response => {
          this.event = response.data.data[0]

          this.totalAttendees = this.extract('event.total_attendees') || 0
          this.maxAttendees = this.extract('event.max_attendees') || 0

          this.availableSlots = Math.max(
            0,
            this.maxAttendees - this.totalAttendees
          )

          this.sponsorshipLevels = this.extract("event.content.membershipOptions", false);

          this.maxRegistrants = this.extract('event.max_per_team')
          // If we need to limit registration to only accept the max number of slots, we can use the following logic:
          // Math.min(this.extract('event.max_per_team'), (this.maxAttendees - this.totalAttendees));

          if (this.maxRegistrants === 1) {
            // Single registration, set-up initial object to avoid null object errors.
            this.registrant.push({ name: '', email: null, terms: false, role: 'Sponsor Organization Point of Contact' })
            this.registrants = 1
          }

          this.loading = false
          // eslint-disable-next-line handle-callback-err
        },
        error => {
          this.$router.push('/404')
        }
      )
  }
}
</script>
